import { IAs2Partner } from '@core/models/as2-message.model';
import As2PartnerQuickActions from 'components/integrations/As2PartnerQuickActions';
import React, { FC } from 'react';

type Props = {
    partners: IAs2Partner[];
    contactEmail?: string;
    onRefresh: () => void;
    onEdit: (partner: IAs2Partner) => void;
};

const WizardSavedPartnersPanel: FC<Props> = ({ partners, contactEmail, onRefresh, onEdit }) => {
    if (partners.length === 0) return null;

    return (
        <div className="mb-4 overflow-x-auto rounded-md border border-slate-200">
            <table className="min-w-full text-left text-xs">
                <thead className="bg-slate-50 text-slate-600">
                    <tr>
                        <th className="px-3 py-2">Code</th>
                        <th className="px-3 py-2">Env</th>
                        <th className="px-3 py-2">Enabled</th>
                        <th className="px-3 py-2">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {partners.map((p) => (
                        <tr key={p.code} className="border-t border-slate-100">
                            <td className="px-3 py-2 font-mono font-medium">{p.code}</td>
                            <td className="px-3 py-2">{p.environment || 'PROD'}</td>
                            <td className="px-3 py-2">{p.enabled ? 'Yes' : 'No'}</td>
                            <td className="px-3 py-2">
                                <As2PartnerQuickActions
                                    partner={p}
                                    contactEmail={contactEmail}
                                    onPartnerUpdated={onRefresh}
                                    onEdit={onEdit}
                                    compact
                                />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <p className="border-t border-slate-100 px-3 py-2 text-[11px] text-slate-500">
                Leave PRODUCTION disabled until test MDN passes, then enable the prod row.
            </p>
        </div>
    );
};

export default WizardSavedPartnersPanel;
